import { useQuery } from '@tanstack/react-query';
import Fetch, { V1 } from 'Util/fetcher';

/**
 * Hook: useReferralBonusInfo
 * --------------------------------------------
 * Fetches referral bonus-info once and caches the result in React-Query.
 * This prevents repeated calls every time a component mounts.
 *
 * staleTime  : 5 min  – within this period data is considered fresh → no refetch
 * cacheTime  : 30 min – data stays in memory after last subscriber unmount
 */
export default function useReferralBonusInfo(options = {}) {
  const queryKey = ['referral-bonus-info'];

  const queryFn = async () => {
    const resp = await Fetch.get(`${V1}transactions/bonuses/bonus-info/`);
    if (!resp.ok) throw new Error(resp.json?.message || 'Failed to load bonus info');
    return resp.json;
  };

  return useQuery(queryKey, queryFn, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}
